export default "__VITE_ASSET__DnLBtEBT__"